module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diandian-home"
  }, [_c('div', {
    staticClass: "dh-nav",
    class: {
      'nav-fixed': _vm.isFixed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dh-banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "dh-1"
  }, [_vm._v("\n                I'm Slide 1\n            ")]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "dh-2"
  }, [_vm._v("\n                I'm Slide 2\n                "), _c('canvas', {
    ref: "waves",
    attrs: {
      "width": "500px",
      "height": "500px",
      "id": "box"
    }
  })]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "dh-3"
  }, [_vm._v("\n                I'm Slide 3\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf7a9be"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Hello.vue
// module id = 228
// module chunks = 1